import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { GET_SYSTEM_STATUS } from "./actionTypes";
import {  getSystemStatusSuccess, getSystemStatusError } from "./actions";

// Include call API
import { getSystemAPI } from "../../../api/system";

const systemAPI = getSystemAPI();

function* getSystemStatusFetch({ payload: { user, history } }) {
  try {
    const response = yield call(systemAPI.getTaskPausedStatus, user.token);
    let task_status = parseInt(response.taskStatus)
    yield put(getSystemStatusSuccess("Get system ok", task_status));
  } catch (error) {
    yield put(getSystemStatusError(error));
  }
}

export function* watchGetSystemStatus() {
  yield takeEvery(GET_SYSTEM_STATUS, getSystemStatusFetch);
}

function* getSystemStatusSaga() {
  yield all([fork(watchGetSystemStatus)]);
}

export default getSystemStatusSaga;
